// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--FzUK3","icon":"_33974c2b58--icon--yB9R1","XS":"_33974c2b58--XS--JTpSd","M":"_33974c2b58--M--TETjN"};